import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Typography, useTheme } from "@mui/material";
import { ViewMacroScenarioDto } from "orval/generated/models";
import { useTranslation } from "react-i18next";
import { CustomIcon, Icons } from "components/common";

type MacroAdjustmentsPageHeaderProps = {
  scenario: ViewMacroScenarioDto;
  handleNavigateToResults: () => void;
  headersIndent: string;
};

const MacroAdjustmentsPageHeader = ({
  scenario,
  handleNavigateToResults,
  headersIndent,
}: MacroAdjustmentsPageHeaderProps) => {
  const { t } = useTranslation("macro");
  const { palette } = useTheme();

  return (
    <Box>
      <Button
        variant="text"
        onClick={handleNavigateToResults}
        startIcon={
          <CustomIcon
            name={Icons.CHEVRON_LEFT}
            width={24}
            height={24}
            fill={palette.primary.main}
          />
        }
        sx={{ padding: 0, py: 1 }}
      >
        {t("adjustmentsPage.backToResults")}
      </Button>
      <Box pr={2} pt={1}>
        <Stack
          direction={{ xs: "column-reverse", md: "row" }}
          justifyContent={{ md: "space-between" }}
          alignItems={{ xs: "flex-start", md: "center" }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            maxWidth={"80%"}
          >
            <Box tabIndex={0}>
              <Typography
                className="text-ellipsis"
                variant={"h1"}
                sx={{
                  padding: headersIndent,
                  transition: "padding 0.3s ease-in-out",
                }}
              >
                {scenario?.name || t("defaultTitle")}
              </Typography>
            </Box>
          </Box>
        </Stack>

        {scenario?.description && (
          <Box width={"90%"} minHeight="45px" mt={1} tabIndex={0}>
            <Typography
              sx={{
                pointerEvents: "none",
                padding: headersIndent,
                transition: "padding 0.3s ease-in-out",
              }}
              overflow="hidden"
              variant={"body1"}
            >
              {scenario?.description}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MacroAdjustmentsPageHeader;
